import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import AuditChangesList from "../../../../../components/AuditChangesList";
import { IAuditoriaTerminalPatio } from "../types/types";

interface Props {
  data?: IAuditoriaTerminalPatio;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <AuditChangesList
          records={props.data ? [props.data] : []}
          statusContext={props.title}
        />
      </div>
    </ModalSideBar>
  );
};

export default Info;
